// Grupos de milhar de verdade: 1 a 3 digitos, depois blocos de EXATAMENTE 3.
// O primeiro digito nao pode ser zero -- "0.500" e meio quilo numa planilha de
// estoque, nao quinhentos, e esta funcao tambem le quantidade. E o bloco tem de
// ter 3 digitos, senao "42.5" e "1.23" (que o teclado do celular produz)
// deixariam de ser decimais.
const SO_MILHAR = /^[1-9]\d{0,2}(\.\d{3})+$/

export function converterNumeroBR(texto: string): number | null {
  const limpo = texto.replace(/[R$\s]/g, '')
  if (limpo === '') return null
  let normalizado: string
  if (limpo.includes(',')) {
    // formato BR: ponto = milhar, virgula = decimal (uma so)
    if ((limpo.match(/,/g) ?? []).length > 1) return null
    normalizado = limpo.replace(/\./g, '').replace(',', '.')
  } else if (SO_MILHAR.test(limpo)) {
    // ⚠ SEM VIRGULA, o ponto de 3 em 3 e MILHAR. Ate 16/08/2026 ele era sempre
    // lido como decimal, e "1.500" -- que e como um brasileiro escreve mil e
    // quinhentos -- virava 1,5. Quem digitava "pedido minimo 1.500" gravava
    // R$ 1,50, sem erro e sem aviso. Valia nos 9 campos de dinheiro do app e
    // tambem na leitura de planilha, que passa por aqui.
    normalizado = limpo.replace(/\./g, '')
  } else {
    normalizado = limpo
  }
  const valor = Number(normalizado)
  return Number.isFinite(valor) ? valor : null
}

export function normalizarTexto(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '') // remove acentos (marcas diacriticas combinantes)
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function somenteDigitos(texto: string): string {
  return texto.replace(/\D/g, '')
}
